<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import ResourceFormFields from '@components/resources/form-fields.svelte'
  import Button from '@components/buttons/button.svelte'
  import { useForm, router } from '@inertiajs/svelte'
  import { Save, FileDown, ChevronLeft } from 'lucide-svelte'

  let { tags = [] } = $props()

  let file = $state(null)
  let cover_image = $state(null)
  let useUrl = $state(false)

  const form = useForm({
    name: '',
    color: 'gray',
    url: '',
    description: '',
    tag_ids: [],
  })

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform((data) => {
      const resource = { ...data }
      if (useUrl) {
        delete resource.file
      } else {
        resource.file = file.file
        resource.url = ''
      }
      return {
        resource,
        cover_image: cover_image?._new ? cover_image.file : undefined,
      }
    })
    $form.post('/admin/resources', {
      onSuccess: () => router.visit('/admin/resources'),
    })
  }

  let navigationProps = {
    title: "New resource",
    Icon: FileDown,
    links: [{ text: "Admin", href: "/admin" }, { text: "Resources", href: "/admin/resources" }],
  }
</script>

<Page.Layout title="New resource">

  <Page.Navigation {...navigationProps} />

  <Page.Titles title="New resource" subtitle="Add a new downloadable resource to the platform">
    {#snippet buttons()}
      <Button text="Back" path="/admin/resources" BeforeIcon={ChevronLeft} />
      <Button type="submit" form="resource-form" text="Create resource" variant="submit" Icon={Save} loading={$form.processing} />
    {/snippet}
  </Page.Titles>

  <Form.Element {form} id="resource-form" onsubmit={handleSubmit}>
    <ResourceFormFields {form} bind:file bind:cover_image bind:useUrl />
  </Form.Element>

</Page.Layout>
